import {ICartPosition} from "@connox/typescript-library";
import * as React from "react";
import {useCartContext} from "../CartContextProvider/CartContextProvider";
import "./ItemList.scss";
import ItemRow from "./ItemRow";

const ItemList: React.FC<{editable?: boolean; goToCartView?: () => void}> = (props) => {
  const {cart} = useCartContext();
  const isRowEditable = props.editable === undefined ? true : props.editable;

  const itemPositions = cart.positions.filter((pos) => pos.reference && pos.reference.itemId !== null);

  if (!itemPositions.length) {
    return null;
  }

  const fixVouchers = cart.positions.filter<ICartPosition>(
    (pos: ICartPosition): pos is ICartPosition => pos.type === "Voucher" && pos.reference?.voucher?.type === "Fix",
  );

  const relativeVouchers = cart.positions.filter<ICartPosition>(
    (pos: ICartPosition): pos is ICartPosition => pos.type === "Voucher" && pos.reference?.voucher?.type === "Relative",
  );

  return (
    <React.Fragment>
      {props.goToCartView && (
        <span className="Pen" onClick={props.goToCartView}>
          <span className="Svg Svg-Icon-Pen">&#160;</span>
        </span>
      )}
      <div>
        <div className="ItemList ArrowBorder">
          {itemPositions.map((position) => (
            <ItemRow
              editable={isRowEditable}
              fixVouchers={fixVouchers}
              position={position}
              relativeVouchers={relativeVouchers}
              key={`ItemRow${position.item ? position.item.itemId : position.text}`}
            />
          ))}
        </div>
        <br />
      </div>
    </React.Fragment>
  );
};

export default ItemList;
